import { Update } from '@ngrx/entity';
import { Action, createAction, props } from '@ngrx/store';
import { InvoiceSessionNumber } from './invoice-session-number.model';

export const loadInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Load InvoiceSessionNumbers',
    props<{ invoiceSessionNumbers: InvoiceSessionNumber[] }>()
);

export const addInvoiceSessionNumber = createAction(
    '[InvoiceSessionNumber/API] Add InvoiceSessionNumber',
    props<{ invoiceSessionNumber: InvoiceSessionNumber }>()
);

export const upsertInvoiceSessionNumber = createAction(
    '[InvoiceSessionNumber/API] Upsert InvoiceSessionNumber',
    props<{ invoiceSessionNumber: InvoiceSessionNumber }>()
);

export const addInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Add InvoiceSessionNumbers',
    props<{ invoiceSessionNumbers: InvoiceSessionNumber[] }>()
);

export const upsertInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Upsert InvoiceSessionNumbers',
    props<{ invoiceSessionNumbers: InvoiceSessionNumber[] }>()
);

export const updateInvoiceSessionNumber = createAction(
    '[InvoiceSessionNumber/API] Update InvoiceSessionNumber',
    props<{ invoiceSessionNumber: Update<InvoiceSessionNumber> }>()
);

export const updateInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Update InvoiceSessionNumbers',
    props<{ invoiceSessionNumbers: Update<InvoiceSessionNumber>[] }>()
);

export const deleteInvoiceSessionNumber = createAction(
    '[InvoiceSessionNumber/API] Delete InvoiceSessionNumber',
    props<{ id: string }>()
);

export const deleteInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Delete InvoiceSessionNumbers',
    props<{ ids: number[] }>()
);

export const removeInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Remove InvoiceSessionNumbers',
    props<{
        ids: number[];
        refetchFilter?: {
            ScheduledStartDate: Date;
            ScheduledEndDate: Date;
            ContractListID: string[];
            ContractDesc: string[];
            showInvoicesOnly: boolean;
            DateRangeView: boolean;
        };
    }>()
);

export const clearInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Clear InvoiceSessionNumbers'
);

export const getInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Get InvoiceSessionNumbers',
    props<{
        ScheduledStartDate: Date;
        ScheduledEndDate: Date;
        ContractListID: string[];
        ContractDesc: string[];
        // showInactive: boolean;
        showInvoicesOnly: boolean;
        DateRangeView: boolean;
    }>()
);

export const putInvoiceSessionNumbers = createAction(
    '[InvoiceSessionNumber/API] Put InvoiceSessionNumbers',
    props<{ sessions: InvoiceSessionNumber[] }>()
);
